import { render, staticRenderFns } from "./modal-windows.vue?vue&type=template&id=3fd54b28"
import script from "./modal-windows.vue?vue&type=script&lang=js"
export * from "./modal-windows.vue?vue&type=script&lang=js"
import style0 from "./modal-windows.vue?vue&type=style&index=0&id=3fd54b28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports